import { render, staticRenderFns } from "./ClassesDropdown.vue?vue&type=template&id=5f530c9a&"
import script from "./ClassesDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClassesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports